enum InventoryRowColPropertyEnum {
    ACTIONS = "actions",
    NAME = "name",
    SKU = "sku",
    DESCRIPTION = "description",
    MSRP = "msrp",
    PRICE_GROUP = "price_group",
    UOM = "uom",
    QTY_ON_HAND = "qty_on_hand",
    RESERVED_QTY_ON_HAND = "reserved_qty_on_hand",
    LAST_UPDATED = "last_updated",
    PACK = "pack",
    QTY_INCOMING = "qty_incoming",
    QTY_BACKORDERED = "qty_backordered",
    QTY_HELD_FOR_BACKORDERS = "qty_held_for_backorders",
    BACKORDER_LIMIT = "backorder_limit",
    LOCATION = "location",
    PURCHASE_LINK = "purchase_link",
    MAP = "map",
}

export default InventoryRowColPropertyEnum;
